import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'time-input',
    templateUrl: './time-input.component.html',
    styleUrls: ['./time-input.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class TimeInputComponent implements OnInit {
  private readonly _componentName = 'TimeInputComponent';

  @Input() public name : string;

  @Output() public changed = new EventEmitter<string>();

  
  private _value : string;

  public get value() : string {
    return this._value;
  }

  @Input()
  public set value(v : string) {
    this._value = v;

    console.log(`${this._componentName}.value set - name=${name} - v=`, v); 
    this.changed.emit(v);    
  }
  

  constructor() { }

  ngOnInit() {
  }

}
